//================================================================
//  Page: My Requests
//================================================================

//  Purpose: This page shows all digital requests assigned to the current user

//================================================================


// Libraries
import React, { useReducer } from 'react';

// Contexts

// Components
import PageComponent from '../../Components/PageComponent/PageComponent';
import TabView from '../../Components/TabView/TabView';

// Tabs
import InProgress from './Tabs/InProgress';
import Rejected from './Tabs/Rejected';
import Completed from './Tabs/Completed';
import Cancelled from './Tabs/Cancelled';
import All from './Tabs/All';

// Functions

// Images

// CSS
import './MyTasks.css';

 
export default function MyTasks() {

  //------------------------------------------------------
  //  useReducer
  //------------------------------------------------------

    // Used to store the total requests per stage/view
    const [requests, setRequests] = useReducer(
      (state, newState) => ({...state, ...newState}),
      {
        'inProgressRequests': [],
        'inProgressRequestsFiltered': [],
        'rejectedRequests': [],
        'rejectedRequestsFiltered': [],
        'completedRequests': [],
        'completedRequestsFiltered': [],
        'cancelledRequests': [],
        'cancelledRequestsFiltered': [],
        'allRequests': [],
        'allRequestsFiltered': [],
      }
    );

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

    return (
      <PageComponent
        body={
          <TabView
            defaultView={1}

            //------------------------------------------------------
            //  In Progress
            //------------------------------------------------------

            oneTitle={
              <div className='flex flex-row gap-2'>
                In Progress
                <div className='flex items-center justify-center h-[22px] w-[22px] rounded-full bg-[#006866] text-white text-[12px] font-bold' hidden={requests?.inProgressRequests?.length === 0}>
                  {requests?.inProgressRequests?.length}
                </div>
              </div>
            }
            oneRoute = {'/myrequests?view=inprogress'}
            oneContent={
              <InProgress
                requests={requests}
                setRequests={setRequests}
              ></InProgress>
            }

            //------------------------------------------------------
            //  Completed
            //------------------------------------------------------

            twoTitle={'Completed'}
            twoRoute = {'/myrequests?view=completed'}
            twoContent={
              <Completed
                requests={requests}
                setRequests={setRequests}
              ></Completed>
            }

            //------------------------------------------------------
            //  Rejected
            //------------------------------------------------------

            threeTitle={
              <div className='flex flex-row gap-2'>
                Rejected
                <div className='flex items-center justify-center h-[22px] w-[22px] rounded-full bg-[#006866] text-white text-[12px] font-bold' hidden={requests?.rejectedRequests?.length === 0}>
                  {requests?.rejectedRequests?.length}
                </div>
              </div>
            }
            threeRoute = {'/myrequests?view=rejected'}
            threeContent={
              <Rejected
                requests={requests}
                setRequests={setRequests}
              ></Rejected>
            }

            //------------------------------------------------------
            //  Cancelled
            //------------------------------------------------------

            fourTitle={'Cancelled'}
            fourRoute = {'/myrequests?view=cancelled'}
            fourContent={
              <Cancelled
                requests={requests}
                setRequests={setRequests}
              ></Cancelled>
            }

            //------------------------------------------------------
            //  All
            //------------------------------------------------------

            fiveTitle={'All'}
            fiveRoute = {'/myrequests?view=all'}
            fiveContent={
              <All
                requests={requests}
                setRequests={setRequests}
              ></All>
            }

          ></TabView>    
        }
      ></PageComponent> 
    )
}
